var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80218 15.0262C5.61989 16.0012 4.89593 20.5461 4.68239 21.8309C4.66676 21.9223 4.6303 21.9578 4.52614 21.9578H0.640721C0.244888 21.9578 -0.0415706 21.6227 0.0105128 21.252L3.0626 2.3664C3.14072 1.8789 3.58864 1.5082 4.10426 1.5082C12.0366 1.5082 12.7032 1.32031 14.7293 2.08711C17.8595 3.27031 18.1459 6.12422 17.0209 9.21172C15.9011 12.3906 13.2449 13.7566 9.72405 13.7973C7.46364 13.8328 6.10426 13.4418 5.80218 15.0262ZM18.5991 7.71875C18.5053 7.65273 18.4688 7.62734 18.4428 7.78476C18.3386 8.36367 18.1772 8.92734 17.9845 9.49101C15.9063 15.2699 10.1459 14.7672 7.33343 14.7672C7.01572 14.7672 6.80739 14.9348 6.76572 15.2445C5.58864 22.3742 5.35426 23.8621 5.35426 23.8621C5.30218 24.2227 5.53655 24.5172 5.90635 24.5172H9.21364C9.66155 24.5172 10.0313 24.1973 10.1199 23.7605C10.1563 23.4863 10.0626 24.0703 10.8699 19.1242C11.1095 18.007 11.6147 18.1238 12.3959 18.1238C16.0938 18.1238 18.9793 16.6613 19.8386 12.4211C20.1772 10.6539 20.0782 8.79531 18.5991 7.71875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypal_icon.049209c5.svg";
export { ForwardRef as ReactComponent };